import {ObjectModelPropertyRootType, ObjectModelPropertyType} from "~/enums/objectModelPropertyType";
import { ObjectModelBuiltinPropertyType } from "./objectModelBuiltinPropertyType";

export enum IndexType {
  Keyword = 'keyword',
  Double = 'double',
  Date = 'date'
}
export const numericIndexProperties: Array<ObjectModelPropertyType> =[
  ObjectModelPropertyRootType.Number,
  ObjectModelPropertyRootType.AutoIncrement,
  ObjectModelPropertyRootType.Aggregate,
];

export const textIndexProperties: Array<ObjectModelPropertyType> =[
  ObjectModelPropertyRootType.Text,
  ObjectModelPropertyRootType.PickList,
  ObjectModelPropertyRootType.DerivedField
]

export const dateIndexProperties: Array<ObjectModelPropertyType> =[
  ObjectModelPropertyRootType.DateTime,

]

export const builtinTextIndexProperties: Array<ObjectModelBuiltinPropertyType> = [
  ObjectModelBuiltinPropertyType.CreatedBy,
  ObjectModelBuiltinPropertyType.RecordHolderEmail,
  ObjectModelBuiltinPropertyType.RecordHolderName,
  ObjectModelBuiltinPropertyType.RecordId,
]

export const builtinDateIndexProperties: Array<ObjectModelBuiltinPropertyType> = [
  ObjectModelBuiltinPropertyType.CreatedAt,
  ObjectModelBuiltinPropertyType.UpdatedAt,
]

export const IndexTypeName = {
  [IndexType.Keyword]: "Text",
  [IndexType.Double]: "Numeric",
  [IndexType.Date]: "Date",

}